import { Row, Col } from "react-bootstrap";
import { useContext } from "react";
import RequestQuoteFormContext from "./RequestQuoteFormContext";
import { ContactAPI } from "../../../api";

const Review = () => {
	const { details, contact, next, prev } = useContext(RequestQuoteFormContext);

	const handleSubmit = async (e) => {
		e.preventDefault();

		const payload = {
			from: details.from.label,
			to: details.to.label,
			quantity: details.quantity,
			weight: details.weight,
			length1: details.length1,
			width: details.width,
			height: details.height,
			description: details.description,
			full_name: contact.full_name,
			email_address: contact.email_address,
			phone_number: contact.phone_number, // wrapped in array
		};

		try {
			await ContactAPI.submitQuoteForm(payload);
			next();
		} catch (err) {
			console.error(err);
			alert("Something went wrong.");
		}
	};

	return (
		<div>
			<Row className="g-3">
				<Col xs={12} md={6} lg={6}>
					<h4 className="mb-3">Contact Information</h4>
					<p>Full Name: {contact.full_name}</p>
					<p>Email Address: {contact.email_address}</p>
					<p>Phone Number: {contact.phone_number}</p>
				</Col>
				<Col xs={12} md={6} lg={6}>
					<h4 className="mb-3">Parcel Information</h4>
					<table className="table table-bordered">
						<tbody>
							<tr>
								<th colSpan={1}>From</th>
								<td colSpan={3}>{details.from.label}</td>
							</tr>

							<tr>
								<th colSpan={1}>To</th>
								<td colSpan={3}>{details.to.label}</td>
							</tr>

							<tr>
								<th colSpan={1}>Quantity</th>
								<td colSpan={1}>{details.quantity}</td>
								<th colSpan={1}>Weight</th>
								<td colSpan={1}>{details.weight}</td>
							</tr>

							<tr>
								<th colSpan={1}>Dimensions:</th>
								<td colSpan={1}>H: {details.height}</td>
								<td colSpan={1}>W: {details.width}</td>
								<td colSpan={1}>L: {details.length1}</td>
							</tr>
							<tr>
								<th colSpan={1}>Description:</th>
								<td colSpan={3}>{details.description}</td>
							</tr>
						</tbody>
					</table>
				</Col>
			</Row>
			<div className="row g-3">
				<div className="col-6 col-md-6 col-lg-6">
					<button onClick={prev} className="btn mt-3 w-100">
						Back
					</button>
				</div>
				<div className="col-6 col-md-6 col-lg-6">
					<button onClick={handleSubmit} className="btn mt-3 w-100">
						Submit
					</button>
				</div>
			</div>
		</div>
	);
};
export default Review;
